'use strict';

module.exports = require('./src/standalone/');



//////////////////
// WEBPACK FOOTER
// ./node_modules/autocomplete.js/index.js
// module id = 233
// module chunks = 0